// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"78b03f91","113":"4a830cc8","258":"0d77685b","421":"19166cfb","610":"b6a1d6fb","783":"72a017a8","882":"16430eaf"}[chunkId] + ".chunk.js";
};